import { toJS } from 'mobx';

export const toJs = (object) => {
  return toJS(object, {
    recurseEverything: true,
    detectCycles: true,
    exportMapsAsObjects: true,
  });
};
